export const defaultMapViewState = {
  longitude: 54.93832899540615,
  latitude: 36.692541276410054,
  zoom: 2.001101874071619,
};
